module.exports = __webpack_public_path__ + "tile-4-overlay-3FG0ysy.webp";